import React, { useEffect } from "react";
import { motion } from "framer-motion";
import DashboardAdmin from "../../components/Dashboard/DashboardAdmin";
import { useSelector } from "react-redux";
import { selectUserInformations } from "../../features/authSlice";
import { hasRole } from "../../utils/utils";
import DashboardInstructor from "../../components/Dashboard/DashboardInstructor";
import DashboardStudent from "../../components/Dashboard/DashboardStudent";
import axios from "axios";
import { API } from "../../shared/api/Api";
import { useLocation } from "react-router-dom";

const pageVariants = {
  initial: { opacity: 0 },
  in: { opacity: 1, transition: { duration: 0.3 } },
  out: { opacity: 0, transition: { duration: 0.2 } },
};

const Home = () => {
  const user = useSelector(selectUserInformations);

  // Ping function to update user's online status
  const pingUserOnline = async () => {
    try {
      await axios.post(
        `${API.Activity.app_activity_pingUserOnline}/${user.uuid}`,
        {},
        { headers: { Authorization: `Bearer ${user.token}` } }
      );
    } catch (error) {
      console.error("Ping failed:", error);
    }
  };

  // Setup ping interval for all users
  useEffect(() => {
    if (user) {
      // Initial ping
      pingUserOnline();
      // Set up recurring pings every 20 seconds
      const interval = setInterval(pingUserOnline, 1000 * 20);
      // Cleanup interval on unmount
      return () => clearInterval(interval);
    }
  }, [user]); // Only re-run if user changes

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
    >
      {hasRole(user.roles, "super-admin") && <DashboardAdmin />}
      {user.isInstructor && <DashboardInstructor />}
      {user.isStudent && <DashboardStudent />}
    </motion.div>
  );
};

export default Home;
